<template>
  <v-app id="appTopView" style="height:100%">
    <div id="appbarTop">
      <app-bar class="mr-4 mr-md-10"/>
    </div>
    <v-main id="mainTop">
      <div class="shape-bar"></div>
        <v-container fluid id="containerTopView" class="md-10">
          <slot></slot>
        </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import AppBar from './AppBar';
  export default {
    name: 'TopView',
    components: {
      AppBar,
    },
  }
</script>

<style lang="scss" scoped>
  #appTopView {
    position: relative;
    width: 100%;
    height: 100%;
  }
  #mainTop {
    position: absolute;
    bottom:0px;
    left: 0px;
    right: 0px;
    top: 70px;
  }
  #appbarTop {
    position: relative;
    top:0px;
    left: 0px;
    right: 0px;
    height: 70px;
  }
  #containerTopView{
    width: 100%;
    height: 90%;
    padding: 0px;
  }
  .shape-bar{
    height: 20px;
    background-color: #ECEEF2;
  }
   @media screen and (max-width: 960) {
    #containerTopView{
     padding: 0px;
    }
  }
@media (max-width: 767px) {

  .shape-bar{
    height: 7px;
  }
  #mainTop {
    top: 60px;
  }
  #appbarTop {
    height: 60px;
  }
  #app-bar{
    height: 60px !important;
  }
  ::v-deep .v-sheet.v-card {
    border-radius: 0 !important;
  }
  ::v-deep .theme--light.v-sheet--outlined{
    border: none !important;
  }
}
</style>